import React from 'react';

// import aos
import Aos from 'aos';
// import aos css
import 'aos/dist/aos.css';

import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Home from './components/page/Home';
import Testimonials from './components/page/Testimonials';
import Header from './components/Header';
import Footer from './components/Footer';

import FormPage from './components/page/Forms/FormPage';
import Pricing from './components/page/Pricing';
import Hero from './components/Hero';
import EconomicCalendar from './components/page/EconomicCalendar';
import ScrollToTop from './components/ScrollToTop';
import Login from './components/page/Login';

const App = () => {
  // initialize aos
  Aos.init({
    duration: 1800,
    offset: 100,
  });

  return (

    <Router>
      <ScrollToTop />
      < Header />
      <Routes>
        <Route path='/' element={< Home />} />
        <Route path='/demo' element={<FormPage />} />
        <Route path='/open-account' element={<Pricing />} />
        <Route path='/testimonials' element={<Testimonials />} />
        <Route path='/vps' element={<Hero />} />
        <Route path='/e-calendar' element={<EconomicCalendar />} />
        <Route path='/login' element={<Login/>} />
      </Routes>
      <Footer />

    </Router>


  );
};

export default App;
